<template>
    <div class="dvgraficobarra">
        <v-chart :options="options"/>
    </div>
</template>
<style>
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficobar",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
		'series'
    ],
    data () {
        return {
            options : {
                title: {
                    text: ''
                },
                color: [
						'#6610f2',  // Indigo
						'#593196',  // Purple
						'#8a5ff2',  // Indigo mais claro
						'#4c0a9c',  // Indigo mais escuro
						'#7a53b3',  // Purple mais claro
						'#4e318a',  // Purple mais escuro
						'#f26135',  // Laranja
						'#40c057',  // Verde
						'#ffc107',  // Amarelo
						'#333333',  // Cinza escuro
						'#cccccc'   // Cinza claro
					],
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    show : false,
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show  : false,
                            title : 'Salvar gráfico'                            
                        }
                    }
                },
                xAxis: {
                    data: [],
                    show: true 
                },
                yAxis: {
                    type: 'value',
                    show : true
                },
                series: 
                    {
                        data: [],
                        type: 'bar',
                        showBackground: false,        
                    }
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        series(){
            this.options.title.text     			= this.titulo;
            this.options.xAxis.data 			    = this.agrupamento;
			this.options.series.data                = this.series;			
        }
    }    
}
</script>